<template>
  <el-form
    label-position="left"
    :model="generalTabForm"
    status-icon
    :rules="generalTabFormRules"
    ref="generalTabForm"
    @submit.native.prevent="next('generalTabForm', generalTabForm)"
  >
    <el-row :gutter="15" justify="center" type="flex" v-loading="saving">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-row :gutter="15">
              <el-col :span="8">
                <el-form-item label="Primer nombre" prop="name1">
                  <el-input
                    size="small"
                    :autofocus="true"
                    v-model="generalTabForm.name1"
                    autocomplete="off"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Segundo nombre" prop="name2">
                  <el-input size="small" v-model="generalTabForm.name2" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Tercer nombre" prop="name3">
                  <el-input size="small" v-model="generalTabForm.name3" autocomplete="off" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="8">
                <el-form-item label="Primer apellido" prop="lastname1">
                  <el-input size="small" v-model="generalTabForm.lastname1" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Segundo apellido" prop="lastname2">
                  <el-input size="small" v-model="generalTabForm.lastname2" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Apellido de casada" prop="lastname3">
                  <el-input size="small" v-model="generalTabForm.lastname3" autocomplete="off" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="8">
                <el-form-item label="Fecha de nacimiento" prop="dob">
                  <el-input
                    size="small"
                    v-model="generalTabForm.dob"
                    placeholder="DD/MM/YYYY"
                    autocomplete="off"
                    clearable
                    prefix-icon="el-icon-date"
                    v-mask="'##/##/####'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Sexo" prop="sex">
                  <el-select
                    v-model="generalTabForm.sex"
                    placeholder="Seleccionar"
                    filterable
                    default-first-option
                    size="small"
                    style="width: 100%"
                  >
                    <el-option v-for="c in sexes" :key="c.id" :label="c.name" :value="c.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Estado civil" prop="civilStatus">
                  <el-select
                    v-model="generalTabForm.civilStatus"
                    placeholder="Seleccionar"
                    filterable
                    default-first-option
                    size="small"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="c in civilStatuses"
                      :key="c.id"
                      :label="c.name"
                      :value="c.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item label="Dirección 1" prop="address1">
                  <el-input size="small" v-model="generalTabForm.address1" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Dirección 2" prop="address2">
                  <el-input size="small" v-model="generalTabForm.address2" autocomplete="off" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="8">
                <el-form-item label="País" prop="country">
                  <el-select
                    v-model="generalTabForm.country"
                    placeholder="Select"
                    filterable
                    default-first-option
                    size="small"
                    style="width: 100%"
                    @change="getStates(generalTabForm.country)"
                  >
                    <el-option v-for="c in countries" :key="c.id" :label="c.name" :value="c.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Departamento" prop="state">
                  <el-select
                    v-model="generalTabForm.state"
                    placeholder="Select"
                    size="small"
                    default-first-option
                    filterable
                    style="width: 100%"
                    @change="getCities(generalTabForm.state)"
                  >
                    <el-option v-for="s in states" :key="s.id" :label="s.name" :value="s.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Municipio" prop="city">
                  <el-select
                    v-model="generalTabForm.city"
                    placeholder="Select"
                    size="small"
                    default-first-option
                    style="width: 100%"
                    filterable
                  >
                    <el-option v-for="c in cities" :key="c.id" :label="c.name" :value="c.id" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="$emit('cancel')" v-if="showCancel">Cancelar</el-button>
            <el-button
              size="small"
              type="primary"
              native-type="submit"
            >{{nextName != null ? nextName : 'Continuar'}}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import dfn from "date-fns";

export default {
  name: "NewContractTabGeneral",
  props: ["values", "nextName", "requireConfirm", "showCancel"],
  beforeCreate() {
    axios
      .post("/", {
        query: `
        {
          countries { id name phoneCode }
          states { id name }
          cities { id name }
          civilStatuses { id name }
        }
      `
      })
      .then(res => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          this.civilStatuses = data.civilStatuses;
          this.countries = data.countries;
          this.states = data.states;
          this.cities = data.cities;
          this.generalTabForm = this.values;
          this.$refs["generalTabForm"].resetFields();
        }
      });
  },
  data() {
    const validateDate = (rule, value, callback) => {
      if (R.isNil(value) || R.isEmpty(value)) {
        callback(new Error("Este campo es requerido"));
        return false;
      }

      const [d, m, y] = value.split("/");
      const date = new Date(`${y}-${m}-${d}`);
      if (!dfn.isValid(date)) {
        callback(new Error("Formato de fecha incorrecto."));
        return false;
      }
      callback();
    };
    return {
      generalTabForm: {
        name1: "",
        name2: "",
        name3: "",
        lastname1: "",
        lastname2: "",
        lastname3: "",
        dob: null,
        address1: null,
        address2: null,
        country: null,
        state: null,
        city: null,
        sex: null,
        civilStatus: null
      },
      generalTabFormRules: {
        name1: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          },
          {
            min: 3,
            message: "Debes ingresar mínimo 3 caracteres",
            trigger: "blur"
          }
        ],
        name2: [
          {
            min: 3,
            message: "Debes ingresar mínimo 3 caracteres",
            trigger: "blur"
          }
        ],
        name3: [
          {
            min: 3,
            message: "Debes ingresar mínimo 3 caracteres",
            trigger: "blur"
          }
        ],
        lastname1: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          },
          {
            min: 3,
            message: "Debes ingresar mínimo 3 caracteres",
            trigger: "blur"
          }
        ],
        lastname2: [
          {
            min: 3,
            message: "Debes ingresar mínimo 3 caracteres",
            trigger: "blur"
          }
        ],
        lastname3: [
          {
            min: 3,
            message: "Debes ingresar mínimo 3 caracteres",
            trigger: "blur"
          }
        ],
        dob: [{ validator: validateDate, trigger: "blur" }],
        address1: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          },
          {
            min: 5,
            max: 50,
            message: "Debes ingresar entre 5 y 50 caracteres",
            trigger: "blur"
          }
        ],
        address2: [
          {
            min: 5,
            max: 50,
            message: "Debes ingresar entre 5 y 50 caracteres",
            trigger: "blur"
          }
        ],
        country: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change"
          }
        ],
        state: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change"
          }
        ],
        city: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change"
          }
        ],
        sex: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change"
          }
        ],
        civilStatus: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change"
          }
        ]
      },
      imageUrl: "",
      sexes: [
        { id: 1, name: "Hombre" },
        { id: 0, name: "Mujer" }
      ],
      civilStatuses: [],
      countries: [],
      states: [],
      cities: [],
      saving: false
    };
  },
  methods: {
    getStates(country) {
      this.$emit("setCountry", country);
      this.generalTabForm.state = null;
      axios
        .post("/", {
          query: `{ states( where: { country: ${country} } ) { id name } }`
        })
        .then(res => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.states = data.states;
          }
        });
    },
    getCities(state) {
      this.generalTabForm.city = null;
      axios
        .post("/", {
          query: `{ cities( where: { state: ${state} } ) { id name } }`
        })
        .then(res => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.cities = data.cities;
          }
        });
    },
    next(formName, datos) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return false;
        }
        this.saving = true;

        let mutation = "";
        if (R.isNil(datos.id)) {
          mutation = `contractCreate(
            data: {
              name1: "${datos.name1}",
              name2: "${R.isNil(datos.name2) ? "" : datos.name2}",
              name3: "${R.isNil(datos.name3) ? "" : datos.name3}",
              lastname1: "${datos.lastname1}",
              lastname2: "${R.isNil(datos.lastname2) ? "" : datos.lastname2}",
              lastname3: "${R.isNil(datos.lastname3) ? "" : datos.lastname3}",
              sex: ${datos.sex},
              civilStatus: ${datos.civilStatus},
              dob: "${datos.dob}",
              address1: "${datos.address1}",
              address2: "${R.isNil(datos.address2) ? "" : datos.address2}",
              country: ${datos.country},
              phoneCode: ${datos.country},
              cellphoneCode: ${datos.country},
              emergencyPhoneCode: ${datos.country},
              state: ${datos.state},
              city: ${datos.city}
            }
          )`;
        } else {
          mutation = `employeeUpdate(
            where: { id: "${datos.id}" },
            data: {
              name1: "${datos.name1}",
              name2: "${datos.name2}",
              name3: "${datos.name3}",
              lastname1: "${datos.lastname1}",
              lastname2: "${datos.lastname2}",
              lastname3: "${datos.lastname3}",
              sex: ${datos.sex},
              civilStatus: ${datos.civilStatus},
              dob: "${datos.dob}",
              address1: "${datos.address1}",
              address2: "${datos.address2}",
              country: ${datos.country},
              phoneCode: ${datos.country},
              cellphoneCode: ${datos.country},
              emergencyPhoneCode: ${datos.country},
              state: ${datos.state},
              city: ${datos.city},
              contractComplete: 1
            }
          )`;
        }

        if (this.requireConfirm) {
          this.$confirm(
            "¿Estás seguro que deseas actualizar estos datos?",
            "Confirmación",
            {
              confirmButtonText: "Si, actualizar",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          )
            .then(() => {
              this.proceedSave(datos, mutation);
            })
            .catch((this.saving = false));
        } else {
          this.proceedSave(datos, mutation);
        }
      });
    },
    proceedSave(datos, mutation) {
      axios
        .post("/", {
          query: `mutation { ${mutation} { id } }`
        })
        .then(res => {
          const { data, error } = res.data;

          if (this.requireConfirm) {
            this.$notify({
              title: "Éxito",
              message: "Se ha actualizado la información correctamente.",
              type: "success"
            });
            this.$emit("save", true);
          } else {
            this.$message("Se ha guardado el avance.");
            const storedId = R.isNil(datos.id)
              ? data.contractCreate.id
              : datos.id;
            this.$emit("next", {
              name: "general",
              data: { ...datos, id: storedId }
            });
          }
        })
        .catch(console.log)
        .then(alw => {
          this.saving = false;
        });
    }
  },
  mounted() {}
};
</script>